/**
 * Browser environment detection utilities
 */

/**
 * Check if current browser is WeChat internal browser
 */
export const isWeChatBrowser = (): boolean => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes('micromessenger');
};

/**
 * Check if current browser is a mobile browser
 */
export const isMobileBrowser = (): boolean => {
  const ua = navigator.userAgent.toLowerCase();
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(ua);
};

/**
 * Check if current browser environment supports Google OAuth
 */
export const isGoogleOAuthSupported = (): boolean => {
  return !isWeChatBrowser();
}; 